module.exports = __webpack_public_path__ + "media/auto_history/pierwsza_rejestracja-3758f9cb.png";